import CSS from "csstype";

export default function Swoosh() {
  const justify: CSS.Properties = {
    width: "100%",
    position: "absolute",
    bottom: "0px",
  };

  const overlay: CSS.Properties = {
    /* Warm Vibe */
    backgroundColor: "#007480",
    borderBottomRightRadius: "36vw",
    width: "100%",
    minWidth: "36vw",
    minHeight: "36vw",
  };
  const swoosh: CSS.Properties = {
    /* SGI Yellow */
    backgroundColor: "#DFE33E",
  };
  return (
    <div style={justify} data-testid="swoosh-test">
      <div style={swoosh}>
        <div style={overlay} />
      </div>
    </div>
  );
}
